import React, { useState } from 'react';
import { Button, Modal, Accordion, Icon, Tab } from 'semantic-ui-react';


const helpTopics = {
  NewSite: {
    questions: [
      { q: 'Which sections of the “Request new site” form do I need to complete?', a: 'All sections need completing to be able to submit your request.' },
      { q: 'What does “Effective from” mean?', a: 'This is the date you became responsible for the property and the utilities.' },
      { q: 'What if I don’t have the meter information?', a: 'This information is mandatory for suppliers to action Change of Tenancies, if you do not have this information you will need to contact the previous occupier to obtain.' },
      { q: 'I don’t have supporting documentation, is this required?', a: 'This information is not mandatory but may be requested by the supplier to support the change, you can submit the change without this but we may request this if they supplier requires evidence.' },
    ],
    videoUrl: 'https://player.vimeo.com/video/890320411'
  },
  NewSiteNonSupplier: {
    questions: [
      { q: 'Which sections of the “Request new site” form do I need to complete?', a: 'All sections need completing to be able to submit your request.' },
      { q: 'What does “Effective from” mean?', a: 'This is the date you became responsible for the property and the utilities.' },
      ],
    videoUrl: 'https://player.vimeo.com/video/890320411'
  },
  newMeter: {
    questions: [
      { q: 'What does “Effective from” mean?', a: 'This is the date you became responsible for the property and the utilities.' },
      { q: 'What if I don’t have the meter information?', a: 'This information is mandatory for suppliers to action Change of Tenancies, if you do not have this information you will need to contact the previous occupier to obtain.' },
      { q: 'I don’t have supporting documentation, is this required?', a: 'This information is not mandatory but may be requested by the supplier to support the change, you can submit the change without this but we may request this if they supplier requires evidence.' },
    ],
    videoUrl: 'https://player.vimeo.com/video/890320548'
  },
  newMeterNonSupplier: {
    questions: [
      { q: 'What does “Effective from” mean?', a: 'This is the date you became responsible for the property and the utilities.' },
      { q: 'What if I don’t have the meter information?', a: 'This information is mandatory for suppliers to action Change of Tenancies, if you do not have this information you will need to contact the previous occupier to obtain.' },
      { q: 'I don’t have supporting documentation, is this required?', a: 'This information is not mandatory but may be requested by the supplier to support the change, you can submit the change without this but we may request this if they supplier requires evidence.' },
    ],
    videoUrl: 'https://player.vimeo.com/video/890320548'
  },
  removeMeterNonSupplier: {
    questions: [
      { q: 'All the meters are showing on the list, is this correct?', a: 'Yes, you can select “remove meter” for those associated with the change, anything that has not been selected will be unaffected.' },
      { q: 'I don’t have supporting documentation, is this required?', a: 'This information is not mandatory but may be required to support the change, you can submit the change without this but we may request this once reviewed. ' },
    ],
    videoUrl: 'https://player.vimeo.com/video/890320501'
  },
  moveOutNonSupplier: {
    questions: [
      { q: 'What does “Move out” mean?', a: 'This option is to be used if you no longer have interest in the property. The property will be the responsibility of a new owner.' },
      { q: 'Will all meters associated with the site be closed down?', a: 'Yes, our internal systems will be updated and the supplier if necessary.' },
      { q: 'I don’t have supporting documentation, is this required?', a: 'This information is not mandatory but may be required to support the change, you can submit the change without this but we may request this once reviewed. ' },
    ],
    videoUrl: 'https://player.vimeo.com/video/890320463'
  },
  
  removeMeter: {
    questions: [
      { q: 'All the meters are showing on the list, is this correct?', a: 'Yes, you can select “remove meter” for those associated with the change, anything that has not been selected will be unaffected.' },
      { q: 'I don’t have supporting documentation, is this required?', a: 'This information is not mandatory but may be requested by the supplier to support the change, you can submit the change without this but we may request this if they supplier requires evidence.' },
    ],
    videoUrl: 'https://player.vimeo.com/video/890320501'
  },
  moveOut: {
    questions: [
      { q: 'What does “Move out” mean?', a: 'This option is to be used if you no longer have interest in the property. The property will be the responsibility of a new owner.' },
      { q: 'Will all meters associated with the site be closed down?', a: 'Yes, our internal systems will be updated and the supplier if necessary.' },
      { q: 'I don’t have supporting documentation, is this required?', a: 'This information is not mandatory but may be requested by the supplier to support the change, you can submit the change without this but we may request this if they supplier requires evidence.' },
    ],
    videoUrl: 'https://player.vimeo.com/video/890320463'
  },
  OtherNonSupplier: {
    questions: [
      { q: 'What does “Other Change mean”?', a: 'This is so you can tell us if something has changed at the property. This could be a serial number has changed or you need the address updating.' },
    ],
    videoUrl: 'https://player.vimeo.com/video/890320463'
  },
  Other: {
    questions: [
      { q: 'What does “Other Change mean”?', a: 'This is so you can tell us if something has changed at the property. This could be a serial number has changed or you need the address updating.' },
    ],
    videoUrl: 'https://player.vimeo.com/video/890320463'
  },
};

const HelpSection = ({ mode = 'default', topic = 'NewSite' }) => {
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const formatCamelCase = (text) => {
    // Insert a space before all caps and capitalize the first letter
    return text
      .replace('NonSupplier', '')
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());
  };

  const renderAccordion = (questions) => (
    <Accordion styled>
      {questions.map((item, index) => (
        <React.Fragment key={index}>
          <Accordion.Title
            active={activeIndex === index}
            index={index}
            onClick={handleClick}
          >
            <Icon name='dropdown' />
            {item.q}
          </Accordion.Title>
          <Accordion.Content active={activeIndex === index}>
            <p>{item.a}</p>
          </Accordion.Content>
        </React.Fragment>
      ))}
    </Accordion>
  );

  const panes = [
    { 
      menuItem: 'Q&A', 
      render: () => <Tab.Pane>{renderAccordion(helpTopics[topic].questions)}</Tab.Pane>
    },
    ...(
      helpTopics[topic].videoUrl ? 
      [{
        menuItem: 'Tutorial', 
        render: () => (
          <Tab.Pane>
            <iframe 
              width="100%" 
              height="315" 
              src={helpTopics[topic].videoUrl}
              title="Tutorial Video"
              allow="autoplay; fullscreen; picture-in-picture" 
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </Tab.Pane>
        ) 
      }] : []
    )
  ];
 
  return (
    <div>
      {mode === 'default' ? (
        <Button color='teal' onClick={() => setOpen(true)}>
          Need Help?
        </Button>
      ) : (
        <Button icon='question circle' color='teal' size='small' onClick={() => setOpen(true)}  
         />
      )}

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        dimmer='blurring'
        size='small'
      >
        <Modal.Header>Help Section - {formatCamelCase(topic)}</Modal.Header>
        <Modal.Content>
          <Tab panes={panes} />
        </Modal.Content>
      </Modal>
    </div>
      
  );
   
};

export default HelpSection;
